// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyQuestionCloudSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 14.793a5.206 5.206 0 0 1 2.703-4.567.264.264 0 0 0 .136-.217 7.346 7.346 0 0 1 12.702-4.628.264.264 0 0 0 .249.077 4.317 4.317 0 0 1 5.215 3.903c.006.089.057.17.135.213A5.563 5.563 0 0 1 18.437 20H5.001C5 20 5 20 5 19.998c0-.001 0-.002-.002-.002A5.208 5.208 0 0 1 0 14.793zm11.99-6.774a3 3 0 0 0-2.977 2.625c-.026.206.145.375.352.375h.75c.207 0 .37-.171.421-.372A1.506 1.506 0 0 1 11.99 9.52c.825 0 1.5.675 1.5 1.5 0 .659-.435.992-.922 1.366-.561.43-1.192.913-1.309 2.008-.022.206.149.376.356.376h.75c.207 0 .37-.171.414-.373.134-.6.583-.993 1.041-1.393.577-.505 1.17-1.022 1.17-1.984a3 3 0 0 0-3-3zm-.75 8.625c0 .207.168.375.375.375h.75a.375.375 0 0 0 .375-.375v-.75a.375.375 0 0 0-.375-.375h-.75a.375.375 0 0 0-.375.375z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyQuestionCloudSolid;
